export default "__VITE_ASSET__2bODouEd__"